import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import subjectRepository from '@/api/repositories/subjectRepository/SubjectRepository.ts';

export const useSubjects = (classId?: string) => {
  return useQuery({
    queryKey: ['subjects', classId ?? 'all'],
    queryFn: async () => {
      const { data, error } = classId
        ? await subjectRepository.findMany({ class_id: classId }, { order: { by: 'created_at', ascending: true } })
        : await subjectRepository.all({ order: { by: 'created_at', ascending: true } });
      if (error) throw new Error(error.message);
      return data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateSubjects = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { name: string; class_id: string }[]) => {
      const { data, error } = await subjectRepository.createMany(payload);
      if (error) throw new Error(error.message);
      if (!data || data.length !== payload.length) {
        throw new Error(`Expected ${payload.length} subjects to be created, got ${data?.length ?? 0}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['subjects'] });
    },
  });
};
